import { enCA, frCA } from "date-fns/locale";
import type { Locale } from "date-fns";

export const getLocaleForDateFormat = (locale?: string): Locale => {
  switch (locale) {
    case "fr":
    case "fr-CA":
      return frCA;
    default:
      return enCA;
  }
};
